export class NoWinDefault {

    public static readonly NO_WIN_GAME_DATA = {
        "reels": [
            [
                "L1",
                "L1",
                "M2",
                "M4",
                "L2",
                "L5"
            ],
            [
                "L3",
                "L2",
                "L2",
                "L4",
                "M1",
                "M5"
            ],
            [
                "M2",
                "M3",
                "L3",
                "L5",
                "M1",
                "M4"
            ],
            [
                "L2",
                "M1",
                "L3",
                "M2",
                "L4",
                "L3"
            ],
            [
                "L3",
                "L2",
                "M5",
                "M2",
                "M3",
                "L2"
            ]
        ],
        "isRestoreState": false,
        "mode": "NORMAL",
        "nextMode": "NORMAL",
        "freespinsLeft": 0,
        "topBottomReelOpened": [
            false,
            false,
            false,
            false,
            false
        ],
        "featureBuyTimesBetValue": [
            {
                "name": "FREESPIN_3_SCATTERS",
                "type": "FREESPIN",
                "additionalTypes": [],
                "price": 100
            },
            {
                "name": "FREESPIN_4_SCATTERS",
                "type": "FREESPIN",
                "additionalTypes": [],
                "price": 500
            },
            {
                "name": "FREESPIN_5_SCATTERS",
                "type": "FREESPIN",
                "additionalTypes": [],
                "price": 2500
            },
            {
                "name": "LUCKY_DRAW",
                "type": "FREESPIN",
                "additionalTypes": [],
                "price": 740
            },
            {
                "name": "BOOSTED_BET_1",
                "type": "BOOSTED_BET",
                "additionalTypes": [],
                "price": 2
            },
            {
                "name": "BOOSTED_BET_2",
                "type": "BOOSTED_BET",
                "additionalTypes": [],
                "price": 45
            }
        ],
        "jumpingWilds": [],
        "stickyWildPositions": "",
        "currenSetupLevel": 0,
        "nextSetupLevel": 0,
        "freeSpinType": "",
        "playerSelect": 0,
        "gambleResult": "",
        "brokeTheBankExecutionType": "",
        "symbolSizes": [
            [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1,
                1
            ]
        ],
        "totalWays": 1024,
        "boostedBetType": ""
    };
}